import { ClientType } from '@/common/constants';

export enum LoginStatusType {
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  PASSED = 'PASSED',
}

export enum EventType {
  LOGIN = 'LOGIN',
  FORGOT_USERNAME = 'FORGOT_USERNAME',
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  ACCOUNT_REGISTRATION = 'ACCOUNT_REGISTRATION',
  CHANGE_PASSWORD = 'CHANGE_PASSWORD',
}

export const EventTypeLabel = {
  [EventType.LOGIN]: 'Login',
  [EventType.FORGOT_USERNAME]: 'Forgot user name',
  [EventType.FORGOT_PASSWORD]: 'Forgot password',
  [EventType.ACCOUNT_REGISTRATION]: 'Account registration',
  [EventType.CHANGE_PASSWORD]: 'Change password',
};

export const TRIGGER_ONLY_EVENTS = [
  EventType.FORGOT_USERNAME,
  EventType.FORGOT_PASSWORD,
  EventType.ACCOUNT_REGISTRATION,
];

export enum FailureReasonType {
  UNCONFIRMED_USER = 'UNCONFIRMED_USER',
  AUTHENTICATION_INCORRECT = 'AUTHENTICATION_INCORRECT',
  APPLICATION_USER_LOCKED_BY_MFA = 'APPLICATION_USER_LOCKED_BY_MFA',
  APPLICATION_USER_LOCKED_BY_ADMIN = 'APPLICATION_USER_LOCKED_BY_ADMIN',
  NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED',
  AUTHENTICATION_RESULT_EMPTY = 'AUTHENTICATION_RESULT_EMPTY',
  MFA_CODE_NOT_MATCH = 'MFA_CODE_NOT_MATCH',
  SESSION_INCORRECT = 'SESSION_INCORRECT',
  CODE_STATUS_INVALID = 'CODE_STATUS_INVALID',
  DEFAULT_FAILURE = 'DEFAULT_FAILURE',
  INCORRECT_PASSWORD = 'INCORRECT_PASSWORD',
  INCORRECT_CODE = 'INCORRECT_CODE',
  PASSWORD_UNCHANGED = 'PASSWORD_UNCHANGED',
  LINK_EXPIRED = 'LINK_EXPIRED',
  LINK_ALREADY_USED = 'LINK_ALREADY_USED',
  LINK_NOT_LATEST = 'LINK_NOT_LATEST',
}

export interface LoginHistory {
  id?: number;
  username?: string;
  eventType?: EventType;
  statusType?: LoginStatusType;
  failureReasonType?: FailureReasonType;
  employeeIds?: number[];
  contactId?: number;
  createdAt?: string;
  sourceType?: ClientType;
  ipAddress?: string;
  geolocation?: string;
  userAgent?: string;
  personalEmail?: string;
  mfaStatusType?: string;
  organizationId?: number;
  organizationPath?: string;
}

export interface LoginHistoryPayload {
  id?: number;
  username?: string;
  event_type?: EventType;
  status_type?: LoginStatusType;
  failure_reason_type?: FailureReasonType;
  employee_ids?: number[];
  contact_id?: number;
  created_at?: string;
  source_type?: ClientType;
  ip_address?: string;
  geolocation?: string;
  user_agent?: string;
  personal_email?: string;
  mfa_status_type?: string;
  organization_id?: number;
  organization_path?: string;
}

export const SourceTypeLabel = {
  [ClientType.WEB_APP]: 'Web application',
  [ClientType.MOBILE_APP]: 'Mobile application',
  [ClientType.PARTNER_SSO]: 'SSO',
  [ClientType.FORGOT_PASSWORD]: 'Forgot password',
  [ClientType.MANAGE_PROFILE]: 'Manage profile',
};

export const LoginStatusTypeLabel = {
  [LoginStatusType.SUCCESS]: 'Successful',
  [LoginStatusType.FAILED]: 'Failure',
  [LoginStatusType.PASSED]: 'Passed',
};

export const FailureReasonTypeLabel = {
  [FailureReasonType.UNCONFIRMED_USER]: 'User is unconfirmed',
  [FailureReasonType.AUTHENTICATION_INCORRECT]: 'Username or password is incorrect',
  [FailureReasonType.APPLICATION_USER_LOCKED_BY_MFA]: 'Account locked by MFA',
  [FailureReasonType.APPLICATION_USER_LOCKED_BY_ADMIN]: 'Account locked by admin',
  [FailureReasonType.NEW_PASSWORD_REQUIRED]: 'New password is required to be set',
  [FailureReasonType.AUTHENTICATION_RESULT_EMPTY]: 'Unknown issue',
  [FailureReasonType.MFA_CODE_NOT_MATCH]: 'MFA not passed',
  [FailureReasonType.SESSION_INCORRECT]: 'MFA session expired',
  [FailureReasonType.CODE_STATUS_INVALID]: 'MFA code is already used',
  [FailureReasonType.DEFAULT_FAILURE]: 'Unknown issue',
  [FailureReasonType.INCORRECT_PASSWORD]: 'Incorrect password',
  [FailureReasonType.INCORRECT_CODE]: 'Incorrect code',
  [FailureReasonType.PASSWORD_UNCHANGED]: 'Password unchanged',
  [FailureReasonType.LINK_EXPIRED]: 'Link expired',
  [FailureReasonType.LINK_ALREADY_USED]: 'Link already used',
  [FailureReasonType.LINK_NOT_LATEST]: 'Link not latest',
};
